module.exports = __webpack_public_path__ + "img/Ted_Bluedrop_IMG_5511.9590cd58.png";